import React, { useState } from "react";
import NewAffiliationModal from "./NewAffiliationModal";
import { Card, CardContent, CardHeader, CardTitle } from "../ui/card";
import { Button } from "../ui/button";
import { OrgTabHeader } from "./orgTabShell";
import { Separator } from "../ui/separator";

/**
 * Explains affiliations and opens the multi-step invitation modal.
 * @param {Object} props
 * @param {number} props.userId
 * @param {Object} props.user
 * @param {function} [props.refreshUser]
 * @returns {JSX.Element}
 */
function NewAffiliationTab({ userId, user, refreshUser }) {
  const [showModal, setShowModal] = useState(false);

  return (
    <div>
      <OrgTabHeader
        title="Create new affiliation"
        description="Invite people to join your organization. They must accept before the link is active."
      />

      <Card className="border-ui-border shadow-profile-sm">
        <CardHeader>
          <CardTitle className="text-lg text-text-primary">How it works</CardTitle>
          <Separator />
        </CardHeader>
        <CardContent className="space-y-4 text-sm leading-relaxed text-text-secondary sm:text-base">
          <p>
            Affiliations connect users to your organization so they can be listed as members, staff, or volunteers.
          </p>
          <ul className="ml-4 list-disc space-y-2">
            <li>The user receives an invitation to join your organization</li>
            <li>They can accept or decline</li>
            <li>After acceptance, the affiliation becomes active</li>
            <li>You can assign a role to organize your team</li>
            <li>Active members show in your member list</li>
          </ul>
          <p>Use this to build your team and keep everyone in one place.</p>
          <div className="pt-2">
            <Button type="button" size="lg" onClick={() => setShowModal(true)}>
              Create affiliation
            </Button>
          </div>
        </CardContent>
      </Card>

      <NewAffiliationModal
        open={showModal}
        onOpenChange={setShowModal}
        userId={userId}
        user={user}
        refreshUser={refreshUser}
      />
    </div>
  );
}

export default NewAffiliationTab;
